import { forwardRef, useState } from "react";

import * as theme from "./AIPromptInput.css";
import { AIPromptInputProps } from "./AIPromptInput.types";
import { AIPromptInputButton } from "./AIPromptInputButton";
import { AIPromptInputTextArea } from "./AIPromptInputTextArea";

export const AIPromptInput = forwardRef<
    HTMLTextAreaElement,
    AIPromptInputProps
>((props, ref) => {
    const {
        placeholder,
        onSubmit,
        disabled = false,
        loading = false,
        submitAriaLabel,
    } = props;
    const [value, setValue] = useState("");

    const isDisabled = disabled || loading;
    const canSubmit = value.trim().length > 0 && !isDisabled;

    const handleSubmit = () => {
        if (canSubmit) {
            onSubmit(value.trim());
            setValue("");
        }
    };

    return (
        <div className={theme.root}>
            <AIPromptInputTextArea
                ref={ref}
                placeholder={placeholder}
                value={value}
                onChange={setValue}
                onSubmit={handleSubmit}
                disabled={isDisabled}
            />
            <div className={theme.buttonRow}>
                <AIPromptInputButton
                    onClick={handleSubmit}
                    disabled={!canSubmit}
                    loading={loading}
                    ariaLabel={submitAriaLabel}
                />
            </div>
        </div>
    );
});
